/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetSurrogateInfoErrorResponse, GetSurrogateInfoResponse } from './api.schemas';

import { api } from '../util/http';

export const getPatientSurrogate = (patientId: string, signal?: AbortSignal) => {
  return api<GetSurrogateInfoResponse>({
    url: `/api/patient/${patientId}/surrogate`,
    method: 'GET',
    signal,
  });
};

export const getGetPatientSurrogateQueryKey = (patientId?: string) => {
  return [`/api/patient/${patientId}/surrogate`] as const;
};

export const getGetPatientSurrogateQueryOptions = <
  TData = Awaited<ReturnType<typeof getPatientSurrogate>>,
  TError = GetSurrogateInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatientSurrogate>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPatientSurrogateQueryKey(patientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPatientSurrogate>>> = ({ signal }) =>
    getPatientSurrogate(patientId, signal);

  return { queryKey, queryFn, enabled: !!patientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPatientSurrogate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPatientSurrogateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPatientSurrogate>>
>;
export type GetPatientSurrogateQueryError = GetSurrogateInfoErrorResponse;

export function useGetPatientSurrogate<
  TData = Awaited<ReturnType<typeof getPatientSurrogate>>,
  TError = GetSurrogateInfoErrorResponse,
>(
  patientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatientSurrogate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientSurrogate>>,
          TError,
          Awaited<ReturnType<typeof getPatientSurrogate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientSurrogate<
  TData = Awaited<ReturnType<typeof getPatientSurrogate>>,
  TError = GetSurrogateInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatientSurrogate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPatientSurrogate>>,
          TError,
          Awaited<ReturnType<typeof getPatientSurrogate>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPatientSurrogate<
  TData = Awaited<ReturnType<typeof getPatientSurrogate>>,
  TError = GetSurrogateInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatientSurrogate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPatientSurrogate<
  TData = Awaited<ReturnType<typeof getPatientSurrogate>>,
  TError = GetSurrogateInfoErrorResponse,
>(
  patientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPatientSurrogate>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPatientSurrogateQueryOptions(patientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
